import { getConfigForImportedTest, getConfigForMeasuredTest, getConfigForTest } from 'Components/Worksheets/Config';
import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import { getMoistureContentPercent } from '../../../MoistureContentWorksheet/Aashto/Config/index';
import qestIds from '../../../QestIds';
import getMeasuredUsingConfig from '../../measuredUsingConfig';
const getConfig = (prefix: string) =>
  mergeConfig(
    {
      ...getConfigForMeasuredTest(
        qestIds.moistureContent.AASHTO_T_265.rev2015,
        'data.Preparation.AssociatedAsReceivedWaterContent'
      ),

      ...getConfigForTest(
        `${prefix}.HydrometerPortion.Preparation.AssociatedMoistureContentTest`,
        qestIds.moistureContent.AASHTO_T_265.rev2015
      ),
      ...getConfigForMeasuredTest(
        qestIds.moistureContent.AASHTO_T_265.rev2015,
        'data.LiquidLimit.EmbeddedWaterContent'
      ),
      ...getConfigForImportedTest(
        qestIds.moistureContent.AASHTO_T_265.rev2015,
        'data.Preparation.AssociatedAsReceivedWaterContent'
      ),
      ...getMoistureContentPercent('data.Preparation.AsReceivedWaterContent'),

      [`${prefix}.Preparation.AssociatedAsReceivedWaterContent.ExternalTest.Results.MoistureContentPercent`]: {
        format: { nearest: 0.1 },
      },

      [`${prefix}.LiquidLimit.Trials.Drops`]: { format: { nearest: 1 } },
      [`${prefix}.LiquidLimit.Trials.LiquidLimit`]: { format: { nearest: 0.1 } },
      ...getConfigForTest(
        qestIds.moistureContent.AASHTO_T_265.rev2015,
        'data.LiquidLimit.Trials.MoistureDetermination'
      ),
      ...getConfigForTest(
        qestIds.moistureContent.AASHTO_T_265.rev2015,
        'data.PlasticLimit.Trials.MoistureDetermination'
      ),

      [`${prefix}.PlasticLimit.Trials.Drops`]: { format: { nearest: 1 } },
      [`${prefix}.Results.PlasticLimit`]: { format: { nearest: 0.1 } },
    },
    getMeasuredUsingConfig(prefix),
    {
      [`${prefix}.Preparation.Balance`]: { defaultReadability: 0.01, defaultUom: 'g' },
      [`${prefix}.PlasticLimit.Balance`]: { defaultReadability: 0.01, defaultUom: 'g' },
      [`${prefix}.PlasticLimit.DryMassBalance`]: { defaultReadability: 0.01, defaultUom: 'g' },
      [`${prefix}.LiquidLimit.Balance`]: { defaultReadability: 0.01, defaultUom: 'g' },
      [`${prefix}.LiquidLimit.DryMassBalance`]: { defaultReadability: 0.01, defaultUom: 'g' },
    }
  );

export default {
  [qestIds.atterbergLimit.AASHTO_T89_T90.methodA_Rev2013_2020]: getConfig,
  [qestIds.atterbergLimit.AASHTO_T89_T90.methodB_Rev2013_2020]: getConfig,
};
